import React, { useEffect ,useState} from 'react'
import RaggingTable from '../table/viewRaging'
import api from '../../API/api'


function RaggingPage() {

  const [data , setData] = useState();

  function getRagging() {
    api.getRagging().then(res => {
      // console.log(res,'asdnsaind');
      setData(res.data)
    }).catch(err => { 
      // console.log(err,'adsd');
    })
  }

  useEffect(() => {
    getRagging();
  },[])


  return (
    <div>
        {/* raging */}
        <RaggingTable ragingData={data} />
    </div>
  )
}

export default RaggingPage